/*
    Developer Name :  RAJA
    Developed Date :  03-12-2021
    Page Name      :  QualityTeam Mst Service
    Created        :  03-12-2021
    Last Edited By : 
    Edited Date    : 
    Last Edited    : 
*/

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QualityTeamApi} from '../../api/master/qualityteam.api';
import { QualityTeamData,QualityTeam  } from '../../interface/master/qualityteam';

@Injectable()
export class QualityTeamService extends QualityTeamData {

  constructor(private api: QualityTeamApi) {
    super();
  }


  list(url: string): Observable<QualityTeam[]> {
    debugger;
    return this.api.list(url);
  }

  getById(url:string): Observable<QualityTeam>{
      return this.api.getById(url);
  }

  create(url: string, data:QualityTeam): Observable<QualityTeam> {
    return this.api.add(url,data);
  }

  update(url: string, data:QualityTeam): Observable<QualityTeam> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
